import React from 'react';

export default function ProfitLoss() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Profit & Loss</h1>
      <p className="text-gray-500">Halaman Profit & Loss</p>
    </div>
  );
}
